import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 16px;\n  color: ", ";\n  font-weight: 600;\n  padding: 0 30px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  box-shadow: ", ";\n  max-height: 375px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n  @media screen and (max-width: ", "px) {\n    max-height: 40vh;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  box-shadow: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transition: opacity 150ms ease-in-out;\n  position: absolute;\n  top: 60px;\n  width: 100%;\n  border-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { SEARCH_NOT_FOUND_MESSAGE } from '../../utils/testing/TestIDs';
import styled from '../../utils/styling/styled-components';
import { Spinner } from '../../Spinner';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.borderRadius.large;
});
var ResultsBox = styled.div(_templateObject2(), function (props) {
  return props.theme.shadows.lgMedium;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.white;
});
var ResultsContainer = styled.div(_templateObject3(), function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.shadows.lgMedium;
}, function (props) {
  return props.theme.breakpoints.md;
});
var NotFoundMessage = styled.div(_templateObject4(), function (props) {
  return props.theme.colors.slate;
});

var ResultBody = function ResultBody(_ref) {
  var results = _ref.results,
      searchString = _ref.searchString,
      isLoading = _ref.isLoading,
      notFoundMessage = _ref.notFoundMessage;

  if (isLoading) {
    return /*#__PURE__*/React.createElement(ResultsContainer, null, /*#__PURE__*/React.createElement(Spinner, {
      height: 24,
      width: 24,
      color: "light-gray"
    }));
  }

  if ((searchString === null || searchString === void 0 ? void 0 : searchString.length) > 0 && (results === null || results === void 0 ? void 0 : results.length) === 0) {
    return /*#__PURE__*/React.createElement(ResultsContainer, null, /*#__PURE__*/React.createElement(NotFoundMessage, {
      "data-testid": SEARCH_NOT_FOUND_MESSAGE
    }, notFoundMessage));
  }

  if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
    return /*#__PURE__*/React.createElement(ResultsContainer, null, results === null || results === void 0 ? void 0 : results.map(function (result, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: "search-result-".concat(index)
      }, result);
    }));
  }

  return null;
};

export var Results = function Results(props) {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ResultsBox, null, /*#__PURE__*/React.createElement(ResultBody, props)));
};